
import moment from 'moment';

// -------------------------------------------------------
// isSplitTxn
// made to work with JS objects and immutables
export function isSplitTxn(txn) {
  return Boolean(txn && txn.split && txn.split.items &&
    (txn.split.items.size ? txn.split.items.size > 0 : txn.split.items.length > 0));
}

// -------------------------------------------------------
// isTransferTxn
export function isTransferTxn(txn) {
  if (isSplitTxn(txn)) {
    return Boolean(txn.split.items.find((item) => item.coa && item.coa.type === 'ACCOUNT'));
  }
  return txn && txn.coa && txn.coa.type === 'ACCOUNT' && txn.coa.id !== txn.accountId;
}

// TODO -------------------------------------------------------------------
// TODO UNIT TESTS!!!
// The core function that all transfer logic depends on, it uses fuzzy logic
// to find the other side of the of a transfer transaction
//
// findMatchingTransferTx - find the matching transfer for <txn> in the list of transactions <txnList>.
//                          match amount is txn.amount, or 'altAmount' if provided
//
// Parms:
//        txn: QCS transaction record
//        txnList: list of QCS transactions from the account on the "other side" of the transfer.  This
//                 list should be pre-filtered to only contain transfer transactions.
//                 e.g. txnList = accountTransactions.filter((x) => isTransferTxn(x));
//        altAmount: override of txn.amount if desired. This is typically used when isSplitTxn(txn) and
//                   we are searching for one the other side of a split item.  In this case we pass in
//                   the split.item[index].amount rather than using txn.amount
//
// The Algorithm:
//
// For each transaction in txnList, we determine if it is a "candidate" for a possible match.  This
// is determined by 4 facets.  Amount (must be exact negative match), Date (distance between dates)
// Payee (exact string match), and coa (coa must be type ACCOUNT, and id must match txn.accountId)
//
// A candidate will exactly match Coa and Amount.  Note, the 4 facets apply individually to split lines
// if the transaction being examined is split.
//
// Once all candidates are determined, they are sorted first by the date delta (exact date matches sort
// to the top), and using payee match as a secondary sort. We then simply return the top sorted item.
//
// IMPROVEMENTS:
//
// This matching will succeed in 99% of the cases.  Error cases can be made to occur by creating transfers
// on the same day, for the same amount, with the same payee name.  We are accepting of imperfection in
// this case since the "error" is virtually meaningless to the user.  In fact, from an accounting perspective,
// there is no error.  If the user placed different tags, memo, or attachments to these transactions, then
// there may be a situation where a mismatch in this extremely rare case causes an issue.  We are NOT solving
// for this very extreme corner case.
//
// However, it would be easy to add the following improvements:
// a) add memo and tags string values as tertiary sorts
// b) use string-similarity (Dice's Coefficient, available in open source libraries) for payee match
//    for slight differences that may have been created.
// c) use 'number of attachments' as a facet as well
//
// It is hard to envision real life use cases where these corner cases matter (we have MUCH bigger fish
// to fry for our users in more core cases in all our clients), but these are ways we could address this
// if desired.
//
//
export function findMatchingTransferTx(txn, txnList, altAmount = null) {

  // we look through txnList for a transaction that matches the given transaction.
  // best indicator is date and amount, and of course, the coa
  //

  // console.log('find matching transfer for ', txn.toJS(), txnList.toJS());

  if (!txnList) {
    return null;
  }

  const srcDate = moment(txn.postedOn);
  const txAmount = altAmount || txn.amount;

  let txnCandidates = [];
  txnList.forEach((listTxn) => {

    let amountFacet;
    let coaFacet;
    const dateFacet = srcDate.diff(moment(listTxn.postedOn), 'day');
    const payeeFacet = listTxn.payee === txn.payee;

    // date should match, will accept close matches
    // amount must match
    // coa's must match
    // payee match helps
    if (isSplitTxn(listTxn)) {
      // log.debug(listTxn.payee, txAmount);
      listTxn.split.items.forEach((splitItem, index) => {
        // log.debug(splitItem);
        if (splitItem.coa.type === 'ACCOUNT' &&
          splitItem.coa.id === txn.accountId &&
          Number(splitItem.amount) === -Number(txAmount)) {
          txnCandidates.push({ dateFacet, payeeFacet, txn: listTxn, splitItem: index });
        }
      });
    } else {

      amountFacet = Number(listTxn.amount) === -Number(txAmount);
      coaFacet = listTxn.coa && (listTxn.coa.type === 'ACCOUNT') && (listTxn.coa.id === txn.accountId);

      if (amountFacet && coaFacet) {
        txnCandidates.push({ dateFacet, payeeFacet, txn: listTxn, splitItem: null });
      }
    }
  });

  // log.debug('candidates:', txnCandidates);
  // TODO score payee matches higher, dates can vary a few days
  if (txnCandidates.length > 1) {

    // sort the list, with the best match coming to the top
    //
    txnCandidates = txnCandidates.sort((a, b) => {
      // primary sort is date delta/difference
      if (a.dateFacet === b.dateFacet) {
        if (a.payeeFacet === b.payeeFacet) {
          return 0;
        }
        // secondary sort if date is an exact match, use payee
        // IMPROVEMENTS: Additional facets (tags,memo,etc.) can be used here
        return (a.payeeFacet ? -1 : 1);
      }
      return Math.abs(a.dateFacet) - Math.abs(b.dateFacet);
    });

  }

  // TODO fix this bug if txCanddidates is empty
  return txnCandidates[0];
}

